import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption } from "../../common/CommonInterfaces";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientContactComponent',
  setup(__props) {

let columnDef = ref([] as ColumnModel[]);
const _searchOptions = {
  fields: [
    "company.Name",
    "email",
    "firstName",
    "lastName",
    "phone",
    "yearOfBirth",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
    },
    { field: "email", headerText: instance?.$t("email") },
    { field: "firstName", headerText: instance?.$t("firstName") },
    { field: "lastName", headerText: instance?.$t("lastName") },
    { field: "phone", headerText: instance?.$t("phone") },
    // { field: "role", headerText: instance?.$t("role") },
    { field: "yearOfBirth", headerText: instance?.$t("yearOfBirth") },
  ];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseGridView, {
    endpoint: "v1/ClientContact/GetData",
    pageTitle: _ctx.$t('Client Contacts'),
    columnDef: (_unref(columnDef) as Array<ColumnModel>),
    searchOptions: _searchOptions
  }, null, 8, ["pageTitle", "columnDef"]))
}
}

})